<template>
  <div>
    <div class="app-content--inner p-0 d-flex flex-column">
      <div class="container-fluid">
        <div class="row" v-if="this.checkStatus != null">
          <div class="col-md-12">
            <div class="card card-box mb-5 p-0">
              <div class="card-body p-0" style="background-color : #CAEBFA">
                <div class="row">
                  <template v-if="this.checkStatus == 'LUNAS'">
                    <div class="col-md-12 col-sm-12 text-center">
                      <div style="margin-top:19%;position:absolute;margin-left:15px;">
                        <h1 class="status-payment">Pembayaran <label class="status-payment-sub">Berhasil</label></h1>
                        <p class="p-status-payment">Terima kasih, pembayaran Anda telah kami terima</p>
                        <b-button @click="
                                      goSubskripsi()
                                      " variant="primary" style="margin-top:15px;">Kembali ke halaman
                          Subskripsi</b-button>
                      </div>
                      <img src="@/assets/img/banner transaction_success.jpg" class="img-fluid">
                    </div>
                  </template>
                  <template v-else>
                    <div class="col-md-12 col-sm-12 text-center">
                      <div style="margin-top:19%;position:absolute;margin-left:15px;">
                        <h1 class="status-payment-gagal">Pembayaran <label
                            class="status-payment-sub-gagal">Gagal</label></h1>
                        <p class="p-status-payment">Mohon maaf pembayaran Anda tidak dapat kami proses. <br>
                          Silakan coba kembali beberapa saat lagi
                        </p>
                        <b-button @click="
                                      goSubskripsi()
                                      " variant="primary" style="margin-top:15px;">Kembali ke halaman
                          Subskripsi</b-button>
                      </div>
                      <img src="@/assets/img/banner transaction_error.jpg" class="img-fluid">
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    library
  } from "@fortawesome/fontawesome-svg-core";
  import {
    faCalendar,
    faInfoCircle
  } from "@fortawesome/free-solid-svg-icons";
  import moment from "moment";
  import {
        mapMutations, mapGetters
    } from "vuex";
  library.add(faCalendar, faInfoCircle);



  export default {
    data: () => {
      return {
        selected: null,
        checkStatus: null,
      }
    },
    async mounted() {
      await this.getStatusInvoince();
    },
    computed: {
      ...mapGetters(["getKlinikId"]),
    },
    methods: {
      convertDate(val) {
        return moment(val).format('DD MMMM YYYY HH:mm:ss ')
      },
      ...mapMutations({
        collapseSidebar: "sidebar/SET_SIDEBAR_COLLAPSED",
        setInitPage: "sidebar/SET_INITIALIZATION_PAGE",
        setUserFirstLogin: "SET_USER_FIRST_LOGIN"
      }),
      goSubskripsi() {
        this.setInitPage(false);
        this.setUserFirstLogin(0);
        this.$router.push({
          name: "subskripsi-klinik",
        });
      },
      async getStatusInvoince() {
        try {
          const bill_id = this.$router.currentRoute.params.bill_id;
          const res = await this.$axios.get(`detailpembayaranbayarind/${bill_id}/${this.getKlinikId}`);
          if(res.data.data) {
            if( res.data.data.detail.status_billing === 'MENUNGGU PEMBAYARAN'){
              const resBayarinCC = await this.$axios.get(`bayarind/failed/${res.data.data.detail.billing_id}`);
            }
            this.checkStatus = res.data.data.detail.status_billing;
          }
        } catch (error) {
          // console.log(error)
        }
      }
    },
  }
</script>

<style scoped>
  .status-payment {
    font-weight: bold;
    color: #299FBF;
    font-size: 2em;
  }

  .status-payment-gagal {
    font-weight: bold;
    color: #F03012;
    font-size: 2em;
  }

  .status-payment-sub {
    font-weight: bold;
    color: #176276;
  }

  .status-payment-sub-gagal {
    font-weight: bold;
    color: #A81C06;
  }

  @media only screen and (max-width: 767px) and (min-width: 500px) {
    .status-payment {
      font-size: 1.5em;
    }

    .status-payment-gagal {
      font-size: 1.5em;
    }

    .p-status-payment {
      font-size: 12px;
    }
  }

  @media only screen and (max-width: 500px) {
    .status-payment {
      font-size: 1em;
      float: left;
    }

    .status-payment-gagal {
      font-size: 1em;
      float: left;
    }

    .p-status-payment {
      float: left;
    }
  }
</style>